import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import ArticleSection from './components/ArticleSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  useEffect(() => {
    document.title = '亚洲五码尺码对照指南——精准选码不再踩坑';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '亚洲五码尺码对照指南',
    url: 'https://docbihd.cn',
    description: '亚洲五码是亚洲地区通用的鞋码/服装尺码标准之一，本页详解亚洲五码与欧码、美码、英码的换算方法，提供男女童装鞋服全品类对照表。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://docbihd.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '亚洲五码对照指南',
    url: 'https://docbihd.cn',
    description: '专业提供亚洲五码与欧码、美码、英码换算对照服务',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@docbihd.cn',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <ArticleSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}